var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-col",
    {
      staticClass: "teas-card-desc-item mobile",
      attrs: { span: _vm.col || 24 },
    },
    [
      _vm._t("icon", function () {
        return [
          _vm.icon
            ? _c("i", {
                staticClass: "teas-card-desc-item-icon",
                class: ["iconfont", _vm.icon],
              })
            : _vm._e(),
        ]
      }),
      _vm._t("label", function () {
        return [
          _vm.label
            ? _c("span", { staticClass: "teas-card-desc-item-label" }, [
                _vm._v(" " + _vm._s(_vm.label) + " "),
              ])
            : _vm._e(),
        ]
      }),
      _vm._t("value", function () {
        return [
          _c("span", { staticClass: "teas-card-desc-item-value" }, [
            _vm._v(_vm._s(_vm.value)),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }